/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export const SET_TOP_OFFSET = '[Sticky Menu] Set Top Offset';

export class SetTopOffset implements Action {
  readonly type = SET_TOP_OFFSET;

  constructor(public payload: any) {}
}

// action types
export type StickyMenuAction = SetTopOffset;
